import { render, staticRenderFns } from "./t-orm-fields.vue?vue&type=template&id=f6313740&lang=pug"
import script from "./t-orm-fields.vue?vue&type=script&lang=js"
export * from "./t-orm-fields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports